import ProductLayout from './ProductLayout';

export default ProductLayout;
